export default "__VITE_ASSET__CIMMEyZ8__"